// 运维平台专用用户 API（使用独立的请求工具）
import opsRequest from '@/utils/opsRequest';

/**
 * 运维平台专用用户相关 API
 */
export const opsUserApi = {
  // 获取用户信息
  getUserInfo() {
    return opsRequest.get('/user/info');
  },

  // 更新用户信息
  updateUser(userData) {
    return opsRequest.post('/user/info/update', userData);
  },

  // 验证当前密码
  verifyPassword(currentPassword) {
    return opsRequest.post('/user/password/verify', { currentPassword });
  },

  // 更新密码
  updatePassword(passwordData) {
    return opsRequest.post('/user/password/update', passwordData);
  }
};

